export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const APK_URL = `${API}/apk/download`;
export const APK_FILE = "Azmthullah_Packers_Movers.apk";

export const PHONES = [
    { label: "+91 99599 56280", tel: "+919959956280", wa: "919959956280" },
    { label: "+91 99599 54280", tel: "+919959954280", wa: "919959954280" },
];

export const ADDRESS =
    "Madeena Complex, Near Gaffariya Function Hall, Alimabad Street, Rayachoty, Andhra Pradesh";

export const MAPS_URL =
    "https://www.google.com/maps/search/?api=1&query=14.0571457,78.7439813";

export const waLink = (num, text) =>
    `https://wa.me/${num}?text=${encodeURIComponent(text)}`;

export const triggerApkDownload = () => {
    const a = document.createElement("a");
    a.href = APK_URL;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const POSTERS = [
    { src: "/poster1.jpg", alt: "Packaging materials — Azmthullah Packers & Movers" },
    { src: "/poster2.jpg", alt: "Relocation services — Azmthullah Packers & Movers" },
    { src: "/poster3.jpg", alt: "Home shifting — Azmthullah Packers & Movers" },
    { src: "/poster4.jpg", alt: "Premium packaging materials — Azmthullah Packers & Movers" },
];
